'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var HeatingAndCoolingAppIcon = function HeatingAndCoolingAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512"
  }), React__default["default"].createElement("g", {
    id: "heating_and_cooling_app_icon",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, React__default["default"].createElement("g", {
    transform: "translate(-1096.000000, -560.000000)",
    id: "hc_logo"
  }, React__default["default"].createElement("g", {
    transform: "translate(1096.000000, 560.000000)"
  }, React__default["default"].createElement("rect", {
    id: "background",
    fill: "#FFFFFF",
    x: "0",
    y: "0",
    width: "512",
    height: "512"
  }), React__default["default"].createElement("g", {
    transform: "translate(89.000000, 64.000000)"
  }, React__default["default"].createElement("polygon", {
    id: "Fill-1",
    fill: "#A41E36",
    points: "0 289.57075 47.7810224 317.149868 47.7810224 250.891213 114.684449 289.57075 114.684449 289.573689 114.684449 355.747115 162.403738 383.273332 162.403738 195.847595 114.684449 168.274355 114.684449 234.45072 47.7810224 195.856412 47.7810224 129.703559 32.4478236 120.839682 0 102.083295"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-2",
    fill: "#A41E36",
    points: "167.199184 0.000587790246 4.79250651 93.7707657 52.4941584 121.344006 60.7780837 116.565271 214.971388 27.5767672"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-3",
    fill: "#A41E36",
    points: "219.776535 90.9693574 57.3727966 184.771864 57.3727966 129.601871 219.776535 35.8963503"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-4",
    fill: "#A41E36",
    points: "62.1782376 193.080867 105.091205 168.302569 105.091205 217.838592"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-5",
    fill: "#A41E36",
    points: "57.3739725 317.090795 57.3739725 267.516566 100.292819 292.327192"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-6",
    fill: "#0668B2",
    points: "196.658857 181.644526 171.998158 195.886683 171.998158 383.274214 334.398957 289.562815 334.398957 234.460418 219.776241 300.648539 219.776241 223.368816 334.398957 157.19539 334.398957 102.084177"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-7",
    fill: "#0668B2",
    points: "281.885103 66.1848878 329.607332 93.7669451 167.230051 187.560635 157.790844 182.105941 119.507821 159.978577 229.371249 96.541315 229.371249 96.5060476"
  }), React__default["default"].createElement("polygon", {
    id: "Fill-8",
    fill: "#0668B2",
    points: "281.885103 198.622847 329.595574 226.143186 229.371249 284.022892 229.371249 228.917556"
  }))))));
};

var HeatingAndCoolingAppIcon$1 = iconStyles()(HeatingAndCoolingAppIcon);

module.exports = HeatingAndCoolingAppIcon$1;
